import { NgClass } from '@angular/common';
import { Component, OnInit } from '@angular/core';

import { SubItemComponent } from '../sub-item.component';

@Component({
    selector: 'picto-sub-item',
    templateUrl: 'picto-sub-item.html',
    styleUrls: ['../sub-item.css'],
    standalone: true,
    imports: [NgClass],
})
export class PictoSubItemComponent extends SubItemComponent implements OnInit {}
